import React, { useEffect, useState } from 'react';
import { Notification } from 'components';

import MessagePrepIcon from 'assests/icons/message-prep.icon';
import CheckBorderIcon from 'assests/icons/check-border.icon';
import DownChevronIcon from 'assests/icons/down-chevron.icon';
import RejectedBorderIcon from 'assests/icons/rejected-border.icon';
import CloseIcon from 'assests/icons/close.icon';
import UploadFileIcon from 'assests/icons/upload-file.icon';
import { Button } from '../index';
import classNames from 'classnames';

import './select-file.less';
import '../MessageList/message-list.less';
import { message, Modal } from 'antd';

const SelectCircles = ({errorMessage="Desteklenmeyen Dosya Türü",allowExtensions=["xlsx","xls"], ...props}) => {
  const [modalReadyMessages, setModalReadyMessages] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState('');
  const [selectFile, setSelectFile] = useState('');

  function selectMessage(message) {
    setSelectedMessage(message);
    props.onChange(message);
  }


  

  return (
    <div
      {...props}
      className={classNames(
        'select-ready-messages',
        props.compClass,
        { uploaded: selectFile || selectedMessage },
        { 'select-ready-messages--vertical': props.vertical },
        { 'select-ready-messages--iconless': props.iconless },
        { 'select-ready-messages--v2': props.typeV2 },
        { 'select-ready-messages--rejected': props.rejected }
      )}
    >
      
        <>
          <div className="status">
            {selectedMessage ? <CheckBorderIcon /> : <MessagePrepIcon />}
          </div>
          <div className="messages-area">
            {selectedMessage ? (
              <>
                <span>Grup Seçildi</span>
                <p>{selectedMessage.name}</p>
              </>
            ) : (
              <span>Grup Seç ve Kullan</span>
            )}
          </div>
          <Button type="ghost" onClick={() => setModalReadyMessages(true)}>
            {selectedMessage.name ? 'Değiştir...' : 'Seç...'}
          </Button>

          <Modal
            title="Gruplarım"
            visible={modalReadyMessages}
            onCancel={() => setModalReadyMessages(false)}
            closeIcon={<CloseIcon />}
            className="modal-ready-messages"
            footer={null}
          >
            <div className="message-list">
              {props.list.map((item, index) => (
                <div
                  onClick={() => {
                    selectMessage(item);
                    setModalReadyMessages(false);
                  }}
                  className="message-list__item"
                  key={'message-item' + index}
                >
                  <p>{item.name}</p>
                  <div>
                    <span>Seç</span>
                    <DownChevronIcon />
                  </div>
                </div>
              ))}
            </div>
          </Modal>
        </>
     
    </div>
  );
};


export default SelectCircles;
